var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "item-details-section" }, [
    _vm.imageURL
      ? _c(
          "div",
          {
            staticClass: "image-wrapper",
            attrs: {
              tabindex: "0",
              "aria-label": `Image of ${_vm.title} ${_vm.description}`,
            },
          },
          [
            _c("img", {
              staticClass: "image",
              attrs: { src: _vm.imageURL, alt: _vm.title },
            }),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "add-item-details" }, [
      _vm.isAlcohol
        ? _c(
            "div",
            {
              staticClass: "alcohol-indicator",
              attrs: { tabindex: "0", "aria-label": "Alcohol" },
            },
            [
              _vm.isAlcohol
                ? _c("img", {
                    staticClass: "icon alcohol-icon",
                    attrs: {
                      src: _vm.$CDN + "/images/alcohol.svg",
                      title: "Alcohol",
                      alt: "Alcohol icon",
                    },
                  })
                : _vm._e(),
              _vm._v("Alcohol\n\t\t"),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "icons-section-wrapper" },
        _vm._l(_vm.allergyIcons, function (allergy) {
          return _c(
            "div",
            { key: allergy.icon, staticClass: "icon-wrapper" },
            [
              _c(
                "icon-base",
                {
                  staticClass: "icon",
                  attrs: {
                    height: "20",
                    width: "20",
                    iconName: allergy.label,
                    tabindex: "0",
                  },
                },
                [_c(allergy.icon, { tag: "component" })],
                1
              ),
              _vm._v("\n\t\t\t\t " + _vm._s(allergy.label) + "\n\t\t\t"),
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.description
        ? _c("div", { staticClass: "add-item-menu-description" }, [
            _vm._v("\n\t\t\t" + _vm._s(_vm.description) + "\n\t\t"),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.price
        ? _c(
            "div",
            {
              staticClass: "add-item-price",
              attrs: { tabindex: "0", "aria-label": "$" + _vm.price },
            },
            [_vm._v("$" + _vm._s(_vm.price))]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }